module.exports = __webpack_public_path__ + "img/elementheights_jaka.c423d866.png";